<template>
    <div>  
        <!-- <li class="m_li m_lih" id="minar" @mouseleave="onMouseOut($event)" @mouseenter="onMouseOver($event)"> -->
        <li class="m_li m_lih" id="minar">
            <a href="https://chatbot.aliyuncs.com/intl/index.htm?locale=zh-CN&from=aJlD8kWRyP">
                <img src="../../assets/picture/rkf.gif" width="28" height="29">
                <em class="mr_wd">美女客服</em>
            </a>
            <!-- <p class="rt_line"></p> -->
            <p class="r_av m_tr" id="m_fma" :style="active">
                <img src="../../assets/image/minapp_qw.jpg" width="120" height="137">
                <em class="r_vt">◆</em>
            </p>
        </li>
    </div>
</template>

<script>
export default{
    data(){
        return{
            active:"",
        }
    },
    methods:{
        onMouseOver($event){
            $event.currentTarget.className="m_li m_lih m_lion";
            this.active="opacity: 1; right: 35px; display: block;"
        },
        onMouseOut($event){
            $event.currentTarget.className="m_li m_lih";
            this.active="opacity: 0; right: 70px; display: none;"
        },
        jieshou(){

        }
    },
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/right-kf.vue